import PropTypes from 'prop-types';
import styles from './FJLanguageSelect.module.less';
import FJDropdownNew from '../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJArrowIcon from '../../../assets/svg/arrow.svg?react';
import FJCheckIcon from '../../../assets/svg/check.svg?react';
import classNames from 'classnames';
import { useRef } from 'react';

import FJTextToSpeechData from '../../../config/dataConfig/FJTextToSpeechData.js';
const languageList = FJTextToSpeechData.LANGUAGE_LIST;
const FJLanguageSelect = props => {
    const { style, onChange, value } = props;
    const _dropDownRef = useRef(null);
    const _renderTrigger = config => {
        const showValue = languageList.find(item => item.value === value).label;
        return (
            <div className={styles.value} onClick={config.onClick} ref={config.ref} style={style}>
                <span className={styles.text}>{showValue}</span>
                <FJArrowIcon />
            </div>
        );
    };

    const _renderOverlay = () => {
        return (
            <div className={styles.box}>
                {languageList.map((item, index) => {
                    return (
                        <div
                            className={classNames(styles.item, item.value === value ? styles.active : '')}
                            key={index}
                            onClick={() => {
                                onChange(item.value);
                                _dropDownRef.current.hide();
                            }}
                        >
                            {item.label} <FJCheckIcon />
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <FJDropdownNew
            isTopLayer={true}
            renderTrigger={_renderTrigger}
            useAnchorBody
            renderOverlay={_renderOverlay}
            offsetTop={5}
            ref={_dropDownRef}
        />
    );
};

FJLanguageSelect.propTypes = {
    style: PropTypes.object,
    onChange: PropTypes.func,
    value: PropTypes.string,
};
export default FJLanguageSelect;
